import s from "./CTA.module.scss";

const CTA = () => {
    return (
        <a href="https://donner.avh.asso.fr/?from=W26&utm_source=lp&utm_medium=organic&utm_campaign=sensibiliser&amount=150&periodicity=oneshot" className={s.CTA} target="_blank">
            Je fais un don
            <span className={s.hoverEffect}></span>
        </a>
    );
};

export default CTA;
